export default "__VITE_ASSET__CJ9kHrIV__"